import i18n from '@/i18n';

export default [
  {
    path: '/payments',
    name: 'payments',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'payment',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('payments')
    },
    // route level code-splitting
    component: () =>
      import('../../views/payments/Index'),
    children: [
      {
        path: ':id(\\d+)',
        name: 'payments-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'payment',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('payments'),
        },
        component: () => import('../../views/payments/Edit.vue'),
      },
    ],
  },
];
